"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ROLLING_SUM = void 0;
const tab_1 = require("../../../tab");
exports.ROLLING_SUM = {
    description: 'Sums selected column values for all rows while a specified column repeats',
    arg_names: ['value_to_sum', 'value_that_repeats', 'ordering_column', 'order_type'],
    args_def: [
        {
            types: ['column', 'number'],
            required: true,
        },
        {
            types: ['column', 'string'],
            required: true,
        },
        {
            types: ['column'],
            required: true,
        },
        {
            types: ['enum(ASC | DESC)'],
            required: true,
        },
    ],
    special_fn_type: 'rolling_sum',
    args_description: ['value to sum', 'value that repeats', 'column to order by', 'order type'],
    return_type: tab_1.ColumnType.NUMBER,
};
